import { render, staticRenderFns } from "./ProvisaoProcedimento.vue?vue&type=template&id=2a6bcb16&scoped=true"
import script from "./ProvisaoProcedimento.vue?vue&type=script&lang=ts"
export * from "./ProvisaoProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./ProvisaoProcedimento.vue?vue&type=style&index=0&id=2a6bcb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bcb16",
  null
  
)

export default component.exports